// The fixed list staff choose from when recording an expense. Details such as
// who was paid or what was bought go in the description, so every expense lands
// in one of these and Finance can file it without anyone mapping it.
//
// Each label (lower-cased) is mapped to a ledger account by the backend
// migration restaurant-ordering/supabase/migrations/027_finance_lean_chart.sql.
// Renaming a label breaks that mapping: add a new mapping row alongside.
export const EXPENSE_CATEGORIES = [
  { label: 'Kenkey', hint: 'Kenkey from suppliers' },
  { label: 'Proteins', hint: 'Fish, chicken, turkey, pork, eggs, sausages' },
  { label: 'Market & ingredients', hint: 'Pepper, onions, oil, shito, ketchup, vegetables' },
  { label: 'Packaging', hint: 'Aluminium pans, white packs, shito cups, paper bags, cake boxes' },
  { label: 'Drinks', hint: 'Sobolo, Ceres, soft drinks and water for resale' },
  { label: 'Riders & delivery', hint: 'Riders, Bolt/Uber, bringing stock from Tema' },
  { label: 'Cooking gas', hint: '' },
  { label: 'Electricity & water', hint: '' },
  { label: 'Airtime & data', hint: '' },
  { label: 'Rent', hint: '' },
  { label: 'Salaries & wages', hint: 'Staff pay and kitchen helpers' },
  { label: 'Cleaning & supplies', hint: 'Tissue, liquid soap, stapler, pins' },
  { label: 'Marketing & printing', hint: 'Stickers, banners, shirts, shoots' },
  { label: 'Repairs & upkeep', hint: 'Fixing things that already exist' },
  { label: 'Equipment & shop', hint: 'Buying new equipment or building the shop' },
  { label: 'Other', hint: 'Anything else — say what in the description' },
];

export const EXPENSE_CATEGORY_LABELS = EXPENSE_CATEGORIES.map((category) => category.label);

// Options for a category <select>. An expense recorded before the fixed list
// keeps its old free-text category as an extra option so editing it doesn't
// silently change it.
export const expenseCategoryOptions = (current) => {
  // Not trimmed: the option's value must equal the stored value exactly.
  const value = String(current || '');
  if (!value.trim() || EXPENSE_CATEGORY_LABELS.includes(value)) return EXPENSE_CATEGORIES;
  return [...EXPENSE_CATEGORIES, { label: value, hint: 'Old category', legacy: true }];
};
